<template>
  <v-container>
    <v-row dense>
      <v-col cols="auto" class="mx-auto">
        <h2 class="ml-4 mr-4 mb-0 font-weight-bold">
          {{ cuestionario.Titulo }}
        </h2>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="auto" class="mx-auto">
        <img
          src="https://d23esi1h40dfmi.cloudfront.net/wp-content/uploads/2021/06/08083209/Logo_2_tintas-e1623141346682.png"
          alt="El Rincón"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="auto" class="mx-auto">
        <p class="ml-8 mr-8">
          Hola,
          <span class="font-weight-bold">
            {{ $store.state.per.PerNom }}
          </span>
        </p>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12">
        <p
          class="ml-8 mr-8 text-center"
          v-html="cuestionario.Descripcion"
        ></p>
      </v-col>
    </v-row>

    <v-row dense justify="center">
      <v-col cols="12" md="8" lg="6">
        <p class="font-weight-bold text-center">
          ¿Te gustaría aparecer en las redes sociales de El Rincón
          y grabar contenido en tu tienda?
        </p>

        <div class="d-flex justify-center">
          <v-radio-group
            v-model="respuestaRedesSociales"
            row
            hide-details
            class="mt-0"
          >
            <v-radio label="Sí" value="Si"></v-radio>
            <v-radio label="No" value="No" class="mr-0"></v-radio>
          </v-radio-group>
        </div>
      </v-col>
    </v-row>

    <v-row dense justify="center">
      <v-col cols="auto">
        <v-btn
          color="primary"
          :loading="loading"
          @click="onClickSaveData"
        >
          Grabar respuesta
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState([
      "empId",
      "perId",
      "perAux",
      "esEmpleado",
      "urlRaiz"
    ])
  },

  data: () => ({
    loading: false,

    cuestionario: {
      Respuestas: []
    },

    respuestaRedesSociales: null,

    respuestas: {
      redesSociales: {
        PreguntasCuestionarioId: 60,
        respuestaUsuario: ""
      }
    }
  }),

  methods: {
    getDataFromApi() {
      this.loading = true;

      return new Promise((resolve, reject) => {
        const controllerParameters = {
          Titulo: "REDES SOCIALES ER"
        };

        const AuthToken = localStorage.getItem("token");

        axios({
          method: "POST",
          url: this.urlRaiz + "/api/cuestionario/get",
          data: JSON.stringify(controllerParameters),
          headers: {
            "content-type": "application/json",
            Authorization: AuthToken
          }
        })
          .then(result => {
            this.loading = false;

            resolve({
              item: result.data.Cuestionario
            });
          })
          .catch(error => {
            this.loading = false;
            alert("Error al cargar el cuestionario");
            reject(error);
          });
      });
    },

    postDataToApi() {
      this.loading = true;

      return new Promise((resolve, reject) => {
        const controllerParameters = {
          Respuestas: [this.respuestas.redesSociales],
          CuestionarioId: this.cuestionario.CuestionarioId,
          PerId: this.perId,
          DirId: 0
        };

        const AuthToken = localStorage.getItem("token");

        axios({
          method: "POST",
          url: this.urlRaiz + "/api/cuestionario/respuesta/save",
          data: JSON.stringify(controllerParameters),
          headers: {
            "content-type": "application/json",
            Authorization: AuthToken
          }
        })
          .then(result => {
            this.loading = false;

            resolve({
              item: result.data.Success
            });
          })
          .catch(error => {
            this.loading = false;
            alert("Error al guardar el cuestionario");
            reject(error);
          });
      });
    },

    loadData() {
      this.getDataFromApi().then(data => {
        this.cuestionario = data.item;
      });
    },

    onClickSaveData() {
      if (!this.esEmpleado) {
        alert(
          "RESPUESTA NO GUARDADA - Estás intentando responder desde el usuario de la tienda. Inicia sesión desde tu intranet personal."
        );
        this.$router.push("/");
        return;
      }

      if (this.respuestaRedesSociales === null) {
        alert("Debes seleccionar Sí o No antes de guardar la respuesta.");
        return;
      }

      this.respuestas.redesSociales.respuestaUsuario =
        this.respuestaRedesSociales;

      this.postDataToApi().then(data => {
        if (data.item) {
          alert("Muchas gracias. Tu respuesta se ha guardado correctamente.");
          this.$router.push("/");
        }
      });
    }
  },

  mounted() {
    this.loadData();
  }
};
</script>